module.exports = "/packs/images/products/tobacco-4c5865afb6a9ad974ad15c8a52bcc111.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/tobacco.jpg
// module id = 737
// module chunks = 0 1 2 4